import React from "react";
import { Box, Container, Paper, Toolbar } from "@mui/material";

type FormLayoutProps = {
  toolbar: React.ReactNode;
  children: React.ReactNode;
};

const FormLayout = ({ toolbar, children }: FormLayoutProps) => {
  return (
    <Container maxWidth="md" sx={{ px: 0 }}>
      <Box>
        <Toolbar
          variant="dense"
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {toolbar}
        </Toolbar>
        <Paper
          sx={{
            py: 2,
            px: {
              xs: 2,
              md: 8,
            },
          }}
        >
          {children}
        </Paper>
      </Box>
    </Container>
  );
};

export default FormLayout;
